import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import LoadingModal from './components/modals/LoadingModal';
import Pagination10 from './components/Pagination10';
import PageCard from './components/PageCard';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import usePagination10 from './components/hooks/usePagination10';
import ItemModal from './components/modalServices/ItemModal';
import usePermissions from './components/hooks/usePermissions';
import useProgramaSituacao from './components/hooks/useProgramaSituacao';

function Itens() {
  // Verificação de permissões
  const { podeAbrir, podeCriar, podeEditar, podeExcluir, podeExportar, carregando: carregandoPermissoes } = usePermissions('itens');
  
  // Verificação de situação do programa
  const { isProgramaAtivo } = useProgramaSituacao();
  
  const [itens, setItens] = useState([]);
  const [atualizar, setAtualizar] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [expandedPrograms, setExpandedPrograms] = useState({});
  const [expandedActions, setExpandedActions] = useState({});
  const [expandedSubActions, setExpandedSubActions] = useState({});
  const [isProgramaInativo, setIsProgramaInativo] = useState(false);
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');

  const totalItems = itens.length;
  const { setPagination } = usePagination10(totalItems);

  // Função para hierarquizar os itens
  const hierarquizarItens = itens => {
    // Verificar se itens é um array válido
    if (!Array.isArray(itens)) {
      console.warn('hierarquizarItens: itens não é um array válido', itens);
      return {};
    }

    const hierarquia = {};

    // Filtrar apenas itens válidos (não null/undefined e com propriedades obrigatórias)
    const itensValidos = itens.filter(
      item =>
        item &&
        item.idPrograma &&
        item.idAcao &&
        item.descricaoPrograma &&
        item.descricaoAcao
    );

    itensValidos.forEach(item => {
      const programaKey = `${item.idPrograma}`;
      const acaoKey = `${item.idPrograma}-${item.idAcao}`;
      const subAcaoKey = item.idSubAcao
        ? `${item.idPrograma}-${item.idAcao}-${item.idSubAcao}`
        : null;

      if (!hierarquia[programaKey]) {
        hierarquia[programaKey] = {
          programa: {
            id: item.idPrograma,
            descricao: item.descricaoPrograma,
          },
          acoes: {},
        };
      }

      if (!hierarquia[programaKey].acoes[acaoKey]) {
        hierarquia[programaKey].acoes[acaoKey] = {
          acao: {
            id: item.idAcao,
            descricao: item.descricaoAcao,
          },
          subAcoes: {},
          itensSemSubAcao: [],
        };
      }

      if (subAcaoKey) {
        if (!hierarquia[programaKey].acoes[acaoKey].subAcoes[subAcaoKey]) {
          hierarquia[programaKey].acoes[acaoKey].subAcoes[subAcaoKey] = {
            subAcao: {
              id: item.idSubAcao,
              descricao: item.descricaoSubAcao,
            },
            itens: [],
          };
        }
        hierarquia[programaKey].acoes[acaoKey].subAcoes[subAcaoKey].itens.push(
          item
        );
      } else {
        hierarquia[programaKey].acoes[acaoKey].itensSemSubAcao.push(item);
      }
    });

    return hierarquia;
  };

  const itensHierarquizados = hierarquizarItens(itens);

  // Para paginação, vamos usar uma lista flat dos itens visíveis
  const selectedItens = itens.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();

  useEffect(() => {
    fetchItens();
  }, [atualizar]);

  function fetchItens() {
    setLoading(true);
    axios
      .get(`${API_BASE_URL.ITEM}/associacao`, {
        params: { cnpjAssociacao: cnpj },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        if (result.data?.length > 0) {
          console.log('Primeiro item:', result.data[0]);
          console.log(
            'Estrutura das chaves do primeiro item:',
            Object.keys(result.data[0] || {})
          );
        }
        console.log('=== FIM DEBUG ===');
        setItens(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter itens:', error);
        navigate('/');
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleDelete(item) {
    showConfirmModal('delete', () => handleConfirmDelete(item));
  }

  function handleConfirmDelete(item) {
    const subAcaoValue =
      item.idSubAcao !== null &&
      item.idSubAcao !== undefined &&
      item.idSubAcao !== 'null'
        ? item.idSubAcao
        : 0;
    const subAcaoSegment = `/${subAcaoValue}`;
    axios
      .delete(
        `${API_BASE_URL.ITEM}/delete/${item.cnpjAssociacao}/${item.idPrograma}/${item.idAcao}${subAcaoSegment}/${item.id}/${item.idElementoDespesa}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(result => {
        setAtualizar(result);
        showDefaultModal('success', 'O registro foi excluído com sucesso!');
      })
      .catch(error => {
        console.error('Erro ao excluir item:', error);
        if (error.response) {
          const status = error.response.status;
          const message = error.response.data;

          if (status === 409) {
            showDefaultModal('error', message); // mensagem personalizada do backend
          } else {
            showDefaultModal('error', message);
          }
        } else {
          showDefaultModal('error', 'Erro de conexão com o servidor!');
        }
      });
  }

  function handleNewItem() {
    setSelectedItem(null);
    setShowModal(true);
  }

  function handleEditItem(item) {
    setSelectedItem(item);
    setTimeout(() => {
      setShowModal(true);
    }, 0);
  }

  const handleSelectRecord = item => {
    const recordKey = `${item.cnpjAssociacao}-${item.idPrograma}-${
      item.idAcao
    }-${item.idSubAcao || 0}-${item.id}`;
    if (selectedRecord && selectedRecord.key === recordKey) {
      setSelectedRecord(null);
      setIsProgramaInativo(false);
    } else {
      setSelectedRecord({ key: recordKey, data: item });
      // Verificar se o programa está encerrado
      const programaAtivo = isProgramaAtivo(item.idPrograma);
      setIsProgramaInativo(!programaAtivo);
    }
  };

  const getSelectedRecord = () => {
    return selectedRecord ? selectedRecord.data : null;
  };

  const hasSelectedRecord = selectedRecord !== null;

  const handleEditSelected = () => {
    const record = getSelectedRecord();
    if (record) {
      handleEditItem(record);
    }
  };

  const handleDeleteSelected = () => {
    const record = getSelectedRecord();
    if (record) {
      handleDelete(record);
    }
  };

  function handleSuccess() {
    setAtualizar([]);
    setShowModal(false);
  }

  // Funções para controlar dropdowns
  const toggleProgram = programId => {
    setExpandedPrograms(prev => ({
      ...prev,
      [programId]: !prev[programId],
    }));
  };

  const toggleAction = (programId, actionId) => {
    const key = `${programId}-${actionId}`;
    setExpandedActions(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const toggleSubAction = (programId, actionId, subActionId) => {
    const key = `${programId}-${actionId}-${subActionId}`;
    setExpandedSubActions(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
      <PageCard
        title="Itens Cadastrados"
        icon="bi-list-ul"
        scrollable={false}
      >
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div className="d-flex flex-wrap gap-1 mb-2 p-2 bg-light rounded border align-items-center">
              <button
                onClick={handleNewItem}
                className="btn btn-success btn-sm d-inline-flex align-items-center"
              >
                <i className="bi bi-plus-lg me-1" />
                Novo
              </button>
              <button
                className="btn btn-primary btn-sm d-inline-flex align-items-center"
                onClick={handleEditSelected}
                disabled={!podeEditar || !hasSelectedRecord || isProgramaInativo}
                title={!podeEditar ? 'Você não tem permissão para editar' : !hasSelectedRecord ? 'Selecione um registro' : isProgramaInativo ? 'Programa ENCERRADO - não é possível editar' : 'Editar registro selecionado'}
              >
                <i className="bi bi-pencil me-1" />
                Editar
              </button>
              <div className="vr mx-1" />
              <button
                className="btn btn-danger btn-sm d-inline-flex align-items-center"
                onClick={handleDeleteSelected}
                disabled={!podeExcluir || !hasSelectedRecord || isProgramaInativo}
                title={!podeExcluir ? 'Você não tem permissão para excluir' : !hasSelectedRecord ? 'Selecione um registro' : isProgramaInativo ? 'Programa ENCERRADO - não é possível excluir' : 'Excluir registro selecionado'}
              >
                <i className="bi bi-trash me-1" />
                Excluir
              </button>
              {hasSelectedRecord && (
                <div className="d-flex align-items-center ms-3 px-3 py-1 bg-warning-subtle border border-warning rounded">
                  <i className="bi bi-check-circle-fill text-warning me-2"></i>
                  <small className="text-dark fw-medium">
                    SELECIONADO:{' '}
                    <span className="fw-bold">
                      {getSelectedRecord()?.descricao}
                    </span>
                  </small>
                </div>
              )}
            </div>

            <LoadingModal loading={isLoading} />
            <div
              className="table-responsive-sm shadow-lg mb-0"
              style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}
            >
              <table className="table table-hover table-sm small">
                <thead className="table-secondary sticky-top bg-light">
                  <tr>
                    <th scope="col" style={{ width: '70%' }}>
                      Hierarquia / Item
                    </th>
                    <th scope="col" style={{ width: '30%' }}>
                      Elemento Despesa
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading &&
                    Object.values(itensHierarquizados)
                      .sort((a, b) => a.programa.id - b.programa.id)
                      .map(programaData => (
                        <React.Fragment key={programaData.programa.id}>
                          {/* Linha do Programa */}
                          <tr
                            className="table-success fw-bold cursor-pointer"
                            onClick={() =>
                              toggleProgram(programaData.programa.id)
                            }
                            style={{ cursor: 'pointer' }}
                          >
                            <td title="Programa - Nível superior da hierarquia">
                              <i
                                className={`bi ${
                                  expandedPrograms[programaData.programa.id]
                                    ? 'bi-folder-minus'
                                    : 'bi-folder-plus'
                                } me-2`}
                              ></i>
                              {programaData.programa.descricao}
                            </td>
                            <td>-</td>
                          </tr>

                          {/* Ações do Programa */}
                          {expandedPrograms[programaData.programa.id] &&
                            Object.values(programaData.acoes)
                              .sort((a, b) => a.acao.id - b.acao.id)
                              .map(acaoData => (
                                <React.Fragment
                                  key={`${programaData.programa.id}-${acaoData.acao.id}`}
                                >
                                  {/* Linha da Ação */}
                                  <tr
                                    className="table-info fw-semibold cursor-pointer"
                                    onClick={() =>
                                      toggleAction(
                                        programaData.programa.id,
                                        acaoData.acao.id
                                      )
                                    }
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <td
                                      className="ps-4"
                                      title="Ação - Segundo nível da hierarquia"
                                    >
                                      <i
                                        className={`bi ${
                                          expandedActions[
                                            `${programaData.programa.id}-${acaoData.acao.id}`
                                          ]
                                            ? 'bi-folder-minus'
                                            : 'bi-folder-plus'
                                        } me-2`}
                                      ></i>
                                      {acaoData.acao.descricao}
                                    </td>
                                    <td>-</td>
                                  </tr>

                                  {/* Itens sem sub-ação */}
                                  {expandedActions[
                                    `${programaData.programa.id}-${acaoData.acao.id}`
                                  ] &&
                                    acaoData.itensSemSubAcao
                                      .sort((a, b) => a.id - b.id)
                                      .map(item => {
                                        const recordKey = `${item.cnpjAssociacao}-${item.idPrograma}-${item.idAcao}-0-${item.id}`;
                                        const isSelected =
                                          selectedRecord &&
                                          selectedRecord.key === recordKey;

                                        return (
                                          <tr
                                            key={recordKey}
                                            className={`${
                                              isSelected ? 'table-warning' : ''
                                            } cursor-pointer`}
                                            onClick={() =>
                                              handleSelectRecord(item)
                                            }
                                            style={{ cursor: 'pointer' }}
                                          >
                                            <td
                                              className="ps-5"
                                              title="Item - Elemento executável da hierarquia"
                                            >
                                              <i className="bi bi-file-earmark me-2 text-primary"></i>
                                              {item.descricao}
                                            </td>
                                            <td>
                                              {item.descricaoElementoDespesa ||
                                                '-'}
                                            </td>
                                          </tr>
                                        );
                                      })}

                                  {/* Sub-ações */}
                                  {expandedActions[
                                    `${programaData.programa.id}-${acaoData.acao.id}`
                                  ] &&
                                    Object.values(acaoData.subAcoes)
                                      .sort(
                                        (a, b) => a.subAcao.id - b.subAcao.id
                                      )
                                      .map(subAcaoData => (
                                        <React.Fragment
                                          key={`${programaData.programa.id}-${acaoData.acao.id}-${subAcaoData.subAcao.id}`}
                                        >
                                          {/* Linha da Sub-ação */}
                                          <tr
                                            className="table-warning cursor-pointer"
                                            onClick={() =>
                                              toggleSubAction(
                                                programaData.programa.id,
                                                acaoData.acao.id,
                                                subAcaoData.subAcao.id
                                              )
                                            }
                                            style={{ cursor: 'pointer' }}
                                          >
                                            <td
                                              className="ps-5"
                                              title="Sub-Ação - Terceiro nível da hierarquia"
                                            >
                                              <i
                                                className={`bi ${
                                                  expandedSubActions[
                                                    `${programaData.programa.id}-${acaoData.acao.id}-${subAcaoData.subAcao.id}`
                                                  ]
                                                    ? 'bi-folder2-open'
                                                    : 'bi-folder2'
                                                } me-2`}
                                              ></i>
                                              {subAcaoData.subAcao.descricao}
                                            </td>
                                            <td>-</td>
                                          </tr>

                                          {/* Itens da Sub-ação */}
                                          {expandedSubActions[
                                            `${programaData.programa.id}-${acaoData.acao.id}-${subAcaoData.subAcao.id}`
                                          ] &&
                                            subAcaoData.itens
                                              .sort((a, b) => a.id - b.id)
                                              .map(item => {
                                                const recordKey = `${item.cnpjAssociacao}-${item.idPrograma}-${item.idAcao}-${item.idSubAcao}-${item.id}`;
                                                const isSelected =
                                                  selectedRecord &&
                                                  selectedRecord.key ===
                                                    recordKey;

                                                return (
                                                  <tr
                                                    key={recordKey}
                                                    className={`${
                                                      isSelected
                                                        ? 'table-warning'
                                                        : ''
                                                    } cursor-pointer`}
                                                    onClick={() =>
                                                      handleSelectRecord(item)
                                                    }
                                                    style={{
                                                      cursor: 'pointer',
                                                    }}
                                                  >
                                                    <td
                                                      className="ps-6"
                                                      style={{
                                                        paddingLeft: '3rem',
                                                      }}
                                                      title="Item - Elemento executável da hierarquia"
                                                    >
                                                      <i className="bi bi-file-earmark me-2 text-primary"></i>
                                                      {item.descricao}
                                                    </td>
                                                    <td>
                                                      {item.descricaoElementoDespesa ||
                                                        '-'}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                        </React.Fragment>
                                      ))}
                                </React.Fragment>
                              ))}
                        </React.Fragment>
                      ))}

                  {!isLoading && itens.length === 0 && (
                    <tr>
                      <td colSpan="3" className="text-center py-3">
                        Nenhum item encontrado.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Removido Pagination10 temporariamente para melhor visualização da hierarquia */}
            <div className="text-center small text-muted mt-2">
              Total de itens: {itens.length}
            </div>
            <ConfirmModal {...setConfirmModal} />
            <DefaultModal {...setDefaultModal} />
        </div>
      {/* Modal para edição/criação de item */}
      <ItemModal
        show={showModal}
        onHide={() => setShowModal(false)}
        item={selectedItem}
        onSuccess={handleSuccess}
      />

      </PageCard>
  );
}

export default Itens;
